(function () {
  if (window.__etrustedPdpPlacementInit) return;
  window.__etrustedPdpPlacementInit = true;

  var config = window.__etrustedPdpPlacementConfig || {};
  var needsBundleApi = !!config.needsBundleApi;
  var WIDGET_SELECTOR = 'etrusted-widget[data-etrusted-widget-id="wdg-6a7492b2-a2f6-4245-9bbf-f2bef544ef7e"]';
  var LIST_ID = 'wdg-6a7492b2-a2f6-4245-9bbf-f2bef544ef7e';
  var placed = false;

  function findThemeWidget() {
    return document.querySelector(WIDGET_SELECTOR);
  }

  function placeWidget(force) {
    if (placed) return true;

    var reservoir = document.getElementById('etrusted-pdp-widget-reservoir');
    var widget = reservoir ? reservoir.querySelector('.etrusted-product-widget') : null;

    if (!widget) {
      widget = document.querySelector('.etrusted-product-widget');
    }

    if (!widget || !findThemeWidget()) return false;

    if (!force) {
      var etrustedWidget = widget.querySelector(WIDGET_SELECTOR) || findThemeWidget();
      if (
        needsBundleApi &&
        (!etrustedWidget.hasAttribute('data-sku') || etrustedWidget.hasAttribute('data-etrusted-resolve-bundle'))
      ) {
        return false;
      }
    }

    document.querySelectorAll('.etrusted-product-widget').forEach(function (node) {
      if (node !== widget) node.remove();
    });

    var anchor = document.querySelector('.shopify-section--related-products, .shopify-section--product-recommendations');
    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(widget, anchor);
    } else {
      var main = document.getElementById('main');
      if (main) {
        main.appendChild(widget);
      } else {
        document.body.appendChild(widget);
      }
    }

    if (reservoir) reservoir.remove();
    widget.classList.remove('etrusted-widget--awaiting-skus');
    placed = true;
    return true;
  }

  window.__etrustedPlacePdpWidget = placeWidget;

  function startPlacementWatch() {
    var observer = new MutationObserver(function () {
      if (placeWidget(false) && observer) observer.disconnect();
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });

    window.setTimeout(function () {
      if (observer) observer.disconnect();
    }, 15000);
  }

  function bootPlacement() {
    placeWidget(needsBundleApi);
  }

  if (needsBundleApi) {
    window.addEventListener(
      'etrusted:bundle-skus-ready',
      function () {
        placeWidget(false);
        if (!placed) startPlacementWatch();
      },
      { once: true }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootPlacement);
  } else {
    bootPlacement();
  }

  if (window.__etrustedStarScrollInit) return;
  window.__etrustedStarScrollInit = true;

  function findList() {
    return (
      document.querySelector('.etrusted-product-widget') ||
      document.querySelector('etrusted-widget[data-etrusted-widget-id="' + LIST_ID + '"]') ||
      document.querySelector('#etrusted-product_review_list')
    );
  }

  function bindStar(star) {
    if (!star || star.dataset.etrustedStarBound === 'true') return;
    star.dataset.etrustedStarBound = 'true';

    star.addEventListener('click', function (event) {
      var list = findList();
      if (!list) return;

      event.preventDefault();
      list.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function bindAll() {
    document.querySelectorAll('.etrusted-product-star').forEach(bindStar);
  }

  bindAll();

  if ('MutationObserver' in window) {
    new MutationObserver(bindAll).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }
})();
